<template>
  <el-dialog
    :title="SetTitle"
    :visible.sync="setDialogVisible"
    @close="OnChangeCalendarResponsibleClose"
  >
    <el-form
      :model="changeCalendarResponsibleForm"
      :rules="rules"
      ref="changeCalendarResponsibleForm"
    >
      <!--
          :CurrentEmployee="CurrentEmployee"-->
      <el-form-item label="Responsable" prop="responsible">
        <EmployeeSelector
          placeholder="Empleados"
          :DireccionParams="46"
          @selection-change="OnEmployeeSelected"
          size="small"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button
        @click="
          OnChangeCalendarResponsibleClose('changeCalendarResponsibleForm')
        "
        >Cancelar</el-button
      >
      <el-button
        type="primary"
        @click="ChangeResponsible('changeCalendarResponsibleForm')"
        >Cambiar</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import EmployeeSelector from "@/components/Company/EmployeeSelector.vue";
export default {
  name: "ChangeCalendarResponsible",
  components: { EmployeeSelector },
  props: {
    showResponsibleChanger: {
      type: Boolean,
      default: false
    },
    CurrentResponsableInfo: {
      type: Object,
      default: () => {}
    },
    CurrentCalendarInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      changeCalendarResponsibleForm: {
        responsible: ""
      },
      rules: {
        responsible: [
          {
            required: true,
            message: "Favor seleccione el nuevo responsable del calendario",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    setDialogVisible() {
      return this.showResponsibleChanger;
    },
    SetTitle() {
      return "Cambiar Responsable del Calendario";
    }
  },
  methods: {
    ChangeResponsible(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            ID: this.CurrentCalendarInfo.CalendariosFP_ID,
            ResponsibleId: this.changeCalendarResponsibleForm.responsible
          };

          this.$http
            .put("/api/CalendarioFinanza/ChangeCalendarResponsible", params)
            .then(() => {
              this.$emit(
                "CalendarResponsibleUpdated",
                this.CurrentCalendarInfo.CalendariosFP_ID
              );
            });
        } else {
          return false;
        }
      });
    },
    OnChangeCalendarResponsibleClose(formName) {
      this.$emit("OnChangeCalendarclose");
      this.$refs[formName].resetFields();
    },
    OnEmployeeSelected(employee) {
      this.changeCalendarResponsibleForm.responsible = employee;
    }
  }
};
</script>

<style></style>
